// extracted by mini-css-extract-plugin
export default {"timeFrameSwitchAndAgendaSizeContainer":"timeFrameSwitchAndAgendaSizeContainer--uExoy","shrinker":"shrinker--TsIsk","expanded":"expanded--bv9B7"};